"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.FundRow = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

var _CheckBox = _interopRequireDefault(require("@mui/icons-material/CheckBox"));

var _InfoIcon = _interopRequireDefault(require("../../../InfoIcon"));

var _helpers = require("../../helpers");

require("../../Calculator.styles.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FundRow = /*#__PURE__*/function (_Component) {
  _inherits(FundRow, _Component);

  var _super = _createSuper(FundRow);

  function FundRow() {
    var _this;

    _classCallCheck(this, FundRow);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "hasAnyBracketValue", function () {
      return _this.props.fundValues.find(function (value) {
        return parseFloat(value) > 0;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onFundSelectionHandler", function (checked) {
      _this.setState({
        checked: checked
      });

      _this.props.onFundSelectionHandler(checked, _this.props.categoryIndex, _this.props.fundIndex);
    });

    return _this;
  }

  _createClass(FundRow, [{
    key: "fundMessageCompose",
    value: function fundMessageCompose(fund) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "CategoryTableRow_fundMessage"
      }, /*#__PURE__*/_react["default"].createElement("div", null, "Ticker Symbol: ".concat(fund.Ticker)));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          fundKey = _this$props.fundKey,
          isViewing = _this$props.isViewing,
          categoryIndex = _this$props.categoryIndex,
          fund = _this$props.fund,
          fundIndex = _this$props.fundIndex,
          fundValues = _this$props.fundValues,
          getBracketError = _this$props.getBracketError,
          _onKeyDown = _this$props.onKeyDown,
          isStatic = _this$props.isStatic,
          onBracketValueChangeHandler = _this$props.onBracketValueChangeHandler,
          onBracketBlurHandler = _this$props.onBracketBlurHandler,
          checked = _this$props.checked,
          fundRowBackgroundColor = _this$props.fundRowBackgroundColor,
          categoryColor = _this$props.categoryColor,
          visibleFundId = _this$props.visibleFundId,
          isInternalView = _this$props.isInternalView; // For some reason data-html2canvas-ignore={someBooleanVariable} as a boolean attribute would not work 
      // so I had to use a spread operator syntax below instead

      return /*#__PURE__*/_react["default"].createElement("tr", _extends({
        key: "fundRow_".concat(fundKey),
        style: {
          backgroundColor: "".concat(fundRowBackgroundColor)
        },
        className: this.hasAnyBracketValue() ? '' : 'hideOnPrint'
      }, this.hasAnyBracketValue() ? {} : {
        'data-html2canvas-ignore': 'true'
      }), /*#__PURE__*/_react["default"].createElement("td", {
        key: "fundName_".concat(fundKey)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "fund_title"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        "data-html2canvas-ignore": true,
        className: "hideOnPrint"
      }, /*#__PURE__*/_react["default"].createElement(_material.Checkbox, {
        disabled: isViewing,
        checked: checked,
        onChange: function onChange(e) {
          return _this2.onFundSelectionHandler(e.target.checked);
        },
        checkedIcon: /*#__PURE__*/_react["default"].createElement(_CheckBox["default"], {
          style: {
            color: categoryColor
          }
        })
      })), /*#__PURE__*/_react["default"].createElement("div", null, fund.FundName), fund.MaximumAllocation < 100 && /*#__PURE__*/_react["default"].createElement("div", {
        "data-html2canvas-ignore": true,
        className: "CategoryTableRow_notes hideOnPrint"
      }, "*"), fund.Message && /*#__PURE__*/_react["default"].createElement("div", {
        "data-html2canvas-ignore": true,
        className: "CategoryTableRow_notes hideOnPrint"
      }, "\u2020"), fund.Ticker && !isInternalView && /*#__PURE__*/_react["default"].createElement("div", {
        "data-html2canvas-ignore": true,
        className: "hideOnPrint"
      }, /*#__PURE__*/_react["default"].createElement(_InfoIcon["default"], {
        message: this.fundMessageCompose(fund)
      })))), !isInternalView ? /*#__PURE__*/_react["default"].createElement("td", {
        key: "fundFeeRate_".concat(fundKey)
      }, (0, _helpers.toFixed3)(fund.FeeRate), "%") : /*#__PURE__*/_react["default"].createElement("td", null), fund.AgeBrackets.map(function (bracket, bracketIndex) {
        var bracketHasError = getBracketError(categoryIndex, fundIndex, bracketIndex);
        var bracketError = bracketHasError ? 'Error' : '';
        var isZero = isNaN(parseFloat(fundValues[bracketIndex])) || parseFloat(fundValues[bracketIndex]) === 0;
        var textAlignEdit = isStatic ? 'center' : 'right';
        var textAlignView = isStatic || isZero ? 'center' : 'right';
        return isViewing ? /*#__PURE__*/_react["default"].createElement("td", {
          key: "bracket_".concat(fundKey, "_").concat(bracketIndex),
          style: {
            textAlign: textAlignView
          }
        }, isZero ? '--' : "".concat((0, _helpers.toFixed2)(fundValues[bracketIndex]), "%")) : /*#__PURE__*/_react["default"].createElement("td", {
          key: "bracket_".concat(fundKey, "_").concat(bracketIndex),
          style: {
            textAlign: textAlignEdit
          }
        }, /*#__PURE__*/_react["default"].createElement("input", {
          type: "text",
          className: "calculator_bracket_input ".concat(bracketError ? 'bracket_error' : ''),
          id: "input_".concat(visibleFundId, "_").concat(bracketIndex),
          onKeyDown: function onKeyDown(e) {
            return _onKeyDown(e, visibleFundId, bracketIndex);
          },
          onChange: function onChange(e) {
            return onBracketValueChangeHandler(e.target.value, categoryIndex, fundIndex, bracketIndex);
          },
          onBlur: function onBlur() {
            return onBracketBlurHandler(categoryIndex, fundIndex, bracketIndex);
          },
          value: fundValues[bracketIndex]
        }));
      }));
    }
  }]);

  return FundRow;
}(_react.Component);

exports.FundRow = FundRow;

_defineProperty(FundRow, "propTypes", {
  fundKey: _propTypes["default"].string.isRequired,
  categoryIndex: _propTypes["default"].number.isRequired,
  fund: _propTypes["default"].object.isRequired,
  fundIndex: _propTypes["default"].number.isRequired,
  fundValues: _propTypes["default"].arrayOf(_propTypes["default"].string).isRequired,
  getBracketError: _propTypes["default"].func.isRequired,
  onBracketValueChangeHandler: _propTypes["default"].func.isRequired,
  onBracketBlurHandler: _propTypes["default"].func.isRequired,
  isViewing: _propTypes["default"].bool.isRequired,
  isInternalView: _propTypes["default"].bool.isRequired,
  onFundSelectionHandler: _propTypes["default"].func.isRequired,
  checked: _propTypes["default"].bool.isRequired,
  fundRowBackgroundColor: _propTypes["default"].string.isRequired,
  categoryColor: _propTypes["default"].string,
  onKeyDown: _propTypes["default"].func.isRequired,
  visibleFundId: _propTypes["default"].number.isRequired,
  isStatic: _propTypes["default"].bool.isRequired
});

var _default = FundRow;
exports["default"] = _default;